import { render } from "./DocumentationBlock .vue?vue&type=template&id=7f438c14&scoped=true"
import script from "./DocumentationBlock .vue?vue&type=script&lang=js"
export * from "./DocumentationBlock .vue?vue&type=script&lang=js"

import "./DocumentationBlock .vue?vue&type=style&index=0&id=7f438c14&scoped=true&lang=css"
import "./DocumentationBlock .vue?vue&type=style&index=1&id=7f438c14&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f438c14"]])

export default __exports__